





























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Room } from "@/types";

@Component
export default class AppBar extends Vue {
  @Prop({ required: true })
  myId!: string;

  @Prop({ required: true })
  room!: Room;

  @Prop({ default: false })
  audioMuted!: boolean;
  @Prop({ default: false })
  videoMuted!: boolean;
  @Prop({ default: false })
  showChat!: boolean;
  @Prop({ default: false })
  showRoomSettings!: boolean;
  @Prop({ default: false })
  showInvite!: boolean;

  unreadChats = 0;

  toggleAudio() {
    this.$emit("toggleAudio");
  }

  toggleVideo() {
    this.$emit("toggleVideo");
  }

  toggleChat() {
    if (!this.showChat) {
      this.unreadChats = 0;
    }
    this.$emit("toggleChat");
  }

  newChat() {
    if (!this.showChat) {
      this.unreadChats += 1;
    }
  }

  exitRoom() {
    if (window.confirm("Are you sure you want to leave the room?")) {
      this.$router.replace({ name: "Main" });
    }
  }

  get amHost() {
    return this.myId === this.room.host;
  }
}
